/**
 * PDP desktop: hover main image — magnified region follows cursor (background pan).
 * Mobile / reduced-motion: no-op.
 */
(function () {
  const DESKTOP = window.matchMedia('(min-width: 750px)');
  const REDUCE_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)');
  const ZOOM_SCALE = 2.35;
  const GLASS_CLASS = 'uucck-pdp-hover-zoom__glass';

  /** @type {WeakSet<Element>} */
  const boundContainers = new WeakSet();

  function enabled() {
    return DESKTOP.matches && !REDUCE_MOTION.matches && document.body.classList.contains('template-product');
  }

  function imageUrl(img) {
    return img.getAttribute('data-max-resolution') || img.currentSrc || img.src;
  }

  function resetContainer(container) {
    if (!container) return;
    container.classList.remove('is-hover-zooming');
    const glass = container.querySelector(`.${GLASS_CLASS}`);
    if (glass) {
      glass.style.backgroundImage = '';
      glass.style.backgroundSize = '';
      glass.style.backgroundPosition = '';
    }
  }

  function ensureGlass(container) {
    let glass = container.querySelector(`.${GLASS_CLASS}`);
    if (glass) return glass;
    glass = document.createElement('div');
    glass.className = GLASS_CLASS;
    glass.setAttribute('aria-hidden', 'true');
    container.appendChild(glass);
    return glass;
  }

  function bindContainer(container) {
    if (boundContainers.has(container)) return;
    const img = container.querySelector('.product-media__image');
    if (!img) return;

    boundContainers.add(container);
    container.classList.add('uucck-pdp-hover-zoom');
    const glass = ensureGlass(container);

    const onMove = (event) => {
      const rect = container.getBoundingClientRect();
      if (rect.width <= 0 || rect.height <= 0) return;

      const relX = (event.clientX - rect.left) / rect.width;
      const relY = (event.clientY - rect.top) / rect.height;
      const bgW = rect.width * ZOOM_SCALE;
      const bgH = rect.height * ZOOM_SCALE;
      const posX = -(relX * bgW - rect.width / 2);
      const posY = -(relY * bgH - rect.height / 2);

      glass.style.backgroundImage = `url("${imageUrl(img)}")`;
      glass.style.backgroundSize = `${bgW}px ${bgH}px`;
      glass.style.backgroundPosition = `${posX}px ${posY}px`;
    };

    const onEnter = (event) => {
      container.classList.add('is-hover-zooming');
      onMove(event);
    };

    const onLeave = () => {
      resetContainer(container);
    };

    container.addEventListener('mouseenter', onEnter);
    container.addEventListener('mouseleave', onLeave);
    container.addEventListener('mousemove', onMove);
  }

  function bindGallery(gallery) {
    gallery.querySelectorAll('.product-media-container--image').forEach(bindContainer);
  }

  function observeGalleries() {
    document.querySelectorAll('.template-product media-gallery.media-gallery--carousel').forEach((gallery) => {
      bindGallery(gallery);
      const root = gallery.querySelector('slideshow-component') || gallery;
      if (root.__uucckPdpHoverZoomObs) return;
      root.__uucckPdpHoverZoomObs = true;

      new MutationObserver(() => {
        bindGallery(gallery);
        gallery.querySelectorAll('slideshow-slide[aria-hidden="true"] .uucck-pdp-hover-zoom').forEach(resetContainer);
      }).observe(root, {
        subtree: true,
        attributes: true,
        attributeFilter: ['aria-hidden', 'hidden'],
        childList: true,
      });
    });
  }

  function boot() {
    if (!enabled()) {
      document.querySelectorAll('.uucck-pdp-hover-zoom').forEach(resetContainer);
      return;
    }
    observeGalleries();
  }

  DESKTOP.addEventListener('change', boot);
  REDUCE_MOTION.addEventListener('change', boot);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
